import axios from "../lib/axios";

export const uploadImages = async (formData) => {
  try {
    const response = await axios.post(`/upload/images`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.error || "Failed to upload images");
  }
};

export const deleteImage = async (url) => {
  try {
    const response = await axios.delete(`/upload/images`, {
      params: { url },
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.error || "Failed to delete image");
  }
};

export const uploadMultipleTypes = async (formData) => {
  try {
    const response = await axios.post(`/upload/document`, formData);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.error || "Failed to upload ZIP file"
    );
  }
};
